var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpWheel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Badge/Icon-12",
    transform: "translate(-8.000000, -9.000000)",
    stroke: "#989FB2",
    strokeWidth: 1.27058824
  }, /*#__PURE__*/React.createElement("g", {
    id: "help-wheel",
    transform: "translate(9.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 9.00075,
    r: 8.625
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 9.00075,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.06725,4.0545 L13.06125,7.0605",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.94025,4.93875 L13.95525,1.92375",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.05375,16.068 L7.05975,13.062",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93875,10.941 L1.93275,13.947",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9515,16.06425 L10.94625,13.059",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.06425,10.935 L16.071,13.94175",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9365,4.04925 L4.941,7.0545",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06575,4.93575 L4.059,1.929",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpWheel);
export default __webpack_public_path__ + "static/media/help-wheel.00fbd5b4.svg";
export { ForwardRef as ReactComponent };